import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminMediaPartnersNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('media-partner');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
